(() => {
  if (!customElements.get('joffz-finish-picker')) {
    customElements.define('joffz-finish-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.ready || this.closest('quick-add-modal')) return;
        this.select = this.closest('fieldset')?.querySelector('select');
        if (!this.select) return;
        this.ready = true;
        this.buttons = [...this.querySelectorAll('[data-value]')];
        this.sync = () => {
          this.buttons.forEach(button => {
            const option = [...this.select.options].find(item => item.value === button.dataset.value);
            const selected = button.dataset.value === this.select.value;
            button.disabled = !option || option.disabled;
            button.setAttribute('aria-checked', String(selected));
            button.tabIndex = selected ? 0 : -1;
          });
        };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-value]');
          if (!button || button.disabled) return;
          this.select.value = button.dataset.value;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
          this.sync();
        });
        this.addEventListener('keydown', event => {
          if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          const available = this.buttons.filter(button => !button.disabled);
          const current = available.indexOf(event.target.closest('[data-value]'));
          if (current < 0 || !available.length) return;
          event.preventDefault();
          const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? available.length - 1 : (current + direction + available.length) % available.length;
          available[next].focus();
          available[next].click();
        });
        this.select.addEventListener('change', this.sync);
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.select, { subtree: true, childList: true, attributes: true });
        this.closest('fieldset').classList.add('joffz-finish-enhanced');
        this.dataset.ready = '';
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.select?.removeEventListener('change', this.sync);
        this.ready = false;
      }
    });
  }
  if (!customElements.get('joffz-product-experience')) {
    customElements.define('joffz-product-experience', class extends HTMLElement {
      connectedCallback() {
        if (this.ready || this.closest('quick-add-modal')) return;
        this.ready = true;
        this.context = this.closest('.product__info-container, [data-jx-root]') || this.parentElement;
        this.dialog = this.querySelector('dialog');
        this.deliveryPanel = this.querySelector('[data-delivery-panel]');
        this.deliveryButton = this.querySelector('[data-delivery-details]');
        this.editor = this.classList.contains('joffz-product-experience--service') ? document.querySelector('[data-jx-root]') : null;
        this.editorFrame = this.editor?.querySelector('[data-jx-frame]');
        this.sync = () => {
          this.querySelectorAll('[data-product-option]').forEach(label => {
            const input = this.context.querySelector(`fieldset[data-option-position="${label.dataset.productOption}"] select`);
            const radio = this.context.querySelector(`fieldset[data-option-position="${label.dataset.productOption}"] input:checked`);
            if ((input || radio) && label.textContent !== (input || radio).value) label.textContent = (input || radio).value;
          });
          const fact = this.querySelector('[data-finish-fact]');
          const finish = (this.editorFrame?.dataset.finish || (fact ? this.querySelector(`[data-product-option="${fact.dataset.finishPosition}"]`)?.textContent : this.dataset.materialValue))?.toLowerCase() || '';
          const material = /canvas|leinwand|kanvas|tuval|toile|lienzo|(?:^|[\s-])tela(?:$|[\s-])/.test(finish) ? 'canvas' : /poster|póster|affiche|lámina|paper|unframed|no frame|rahmenlos|papier|kağıt|kâğıt/.test(finish) ? 'poster' : /frame|rahmen|çerçeve|cadre|cornice|marco|telaio/.test(finish) ? 'frame' : '';
          if (fact) {
            const text = material ? fact.dataset[material] || '' : '';
            if (fact.textContent !== text) fact.textContent = text;
          }
          const paperSpecs = this.querySelector('[data-paper-specs]');
          if (paperSpecs) paperSpecs.hidden = material !== 'poster';
        };
        this.context.addEventListener('change', this.sync);
        if (this.editorFrame) {
          this.editorObserver = new MutationObserver(this.sync);
          this.editorObserver.observe(this.editorFrame, { attributes: true, attributeFilter: ['data-finish'] });
        }
        const sizeControl = button => {
          const fieldset = this.context.querySelector(`fieldset[data-option-position="${button.dataset.sizePosition}"]`);
          const select = fieldset?.querySelector('select');
          const value = select ? [...select.options].find(option => option.value === button.dataset.selectSize) : [...(fieldset?.querySelectorAll('input[type="radio"]') || [])].find(radio => radio.value === button.dataset.selectSize);
          return {select, value};
        };
        this.addEventListener('click', event => {
          if (event.target.closest('[data-editor-size-guide]')) this.editor?.querySelector('[data-open="size"]')?.click();
          if (event.target.closest('[data-delivery-details]') && this.deliveryPanel) {
            this.deliveryPanel.open = !this.deliveryPanel.open;
            this.deliveryButton?.setAttribute('aria-expanded', String(this.deliveryPanel.open));
          }
          if (event.target.closest('[data-size-guide]')) {
            this.opener = event.target.closest('[data-size-guide]');
            this.dialog?.querySelectorAll('[data-select-size]').forEach(button => {
              const {value} = sizeControl(button);
              button.disabled = !value || value.disabled;
            });
            this.dialog?.showModal();
          }
          if (event.target.closest('[data-close-guide]')) this.dialog?.close();
          const choice = event.target.closest('[data-select-size]');
          if (choice && !choice.disabled) {
            const {select, value} = sizeControl(choice);
            if (select && value) {
              select.value = choice.dataset.selectSize;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              this.sync();
            } else if (value) {
              value.checked = true;
              value.dispatchEvent(new Event('change', { bubbles: true }));
              this.sync();
            }
            this.dialog?.close();
          }
        });
        this.dialog?.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog?.addEventListener('close', () => this.opener?.focus());
        this.deliveryPanel?.addEventListener('toggle', () => this.deliveryButton?.setAttribute('aria-expanded', String(this.deliveryPanel.open)));
        this.sync();
      }
      disconnectedCallback() {
        this.context?.removeEventListener('change', this.sync);
        this.editorObserver?.disconnect();
        this.ready = false;
      }
    });
    document.addEventListener('shopify:section:load', () => {
      const main = document.querySelector('.js-media-list');
      const sub = document.querySelector('.js-media-sublist');
      if (main && typeof Swiper !== 'undefined' && typeof getSliderSettings !== 'undefined' && !main.swiper) new Swiper(main, getSliderSettings);
      if (sub && typeof Swiper !== 'undefined' && typeof getSubSliderProductSettings !== 'undefined' && !sub.swiper) new Swiper(sub, getSubSliderProductSettings);
    });
  }
})();
